// Import global assets
import type { Plugin } from 'vue'
import PrimeVue from 'primevue/config'
import './assets/styles/global.scss'

import * as components from './components'

import { Tooltip } from './directives'

// Create module definition for Vue.use()
const BlokInkPlugin = {
  installed: false,

  install(app, options) {
    app.use(PrimeVue)

    if (this.installed) {
      return
    }

    this.installed = true
    const hasComponentsOption = options && options.withComponents?.length > 0

    for (const key in components) {
      if (hasComponentsOption && options.withComponents.includes(key)) {
        app.component(key, components[key as keyof typeof components])
      } else if (!hasComponentsOption) {
        app.component(key, components[key as keyof typeof components])
      }
    }

    app.directive('tooltip', Tooltip)
  },
} as Plugin & { installed: boolean }

// Exporting components
export * from './components'

// Exporting directives
export * from './directives'

// Exporting the plugin definition to Vue.use
export default BlokInkPlugin
